module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " a\u017E ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "Vybr\xE1no ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "Kliknut\xEDm dokon\u010D\xEDte v\xFDb\u011Br rozsahu dat",
  "maximumDate": "Posledn\xED dostupn\xE9 datum",
  "minimumDate": "Prvn\xED dostupn\xE9 datum",
  "next": "Dal\u0161\xED",
  "previous": "P\u0159edchoz\xED",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Vybran\xE9 datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Vybran\xE9 obdob\xED: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknut\xEDm zah\xE1j\xEDte v\xFDb\u011Br rozsahu dat",
  "todayDate": function todayDate(args) {
    return "Dnes, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Dnes, vybr\xE1no ".concat(args.date);
  }
};